export const getTimeRemaining = endtime => {
  let dueDateClasses;
  const startDate = new Date().toLocaleDateString('en-US');
  const endDate = new Date(endtime).toLocaleDateString('en-US');

  // One day in milliseconds
  const oneDay = 1000 * 60 * 60 * 24;

  // Calculating the time difference between two dates
  const diffInTime = new Date(endDate) - new Date(startDate);
  const days = Math.round(diffInTime / oneDay);

  switch (true) {
    case days >= 7:
      dueDateClasses = 'due-date-green';
      break;

    case days < 7 && days >= 1:
      dueDateClasses = 'due-date-orange';
      break;

    case days === 0 || days < 0:
      dueDateClasses = 'due-date-red';
      break;

    default:
      break;
  }
  return { days, dueDateClasses };
};
